module.exports = __webpack_public_path__ + "img/featureTreeBlue.c7fff71d.png";